import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ModalComponent } from '../../../ui/modal-component/modal-component.component';
import { FormWrapperComponent } from '../../../ui/form-wrapper/form-wrapper.component';
import { InputFieldComponent } from '../../../ui/inputField/inputField.component';
import { CampaignDetails } from '../../../../pages/organization/campaigns/types/campaignDetails';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { CustomizableButtonComponent } from '../../../ui/customizable-button/customizable-button.component';
import { CampaignsService } from '../../../../services/campaign/campaigns-api.service';

@Component({
  selector: 'app-edit-campaign-details',
  standalone: true,
  imports: [
    ModalComponent,
    FormWrapperComponent,
    InputFieldComponent,
    ReactiveFormsModule,
    CustomizableButtonComponent,
  ],
  templateUrl: './edit-campaign-details.component.html',
  styleUrl: '../campaign-form.css',
})
export class EditCampaignDetailsComponent implements OnInit {
  @Output() onClose = new EventEmitter();
  @Input({ required: true }) openModal = false;
  @Input() title = 'Edit campaign details';
  @Input() campaignData!: CampaignDetails;
  campaignsService = inject(CampaignsService);

  constructor(private fb: FormBuilder) {}

  campaignDetailsForm = this.fb.group({
    name: ['', Validators.required],
    description: ['', Validators.required],
    startDate: ['', Validators.required],
    endDate: ['', Validators.required],
  });

  submitted = false;

  /** The end date can only move later: the current end date is the earliest allowed. */
  get minEndDate(): string {
    return toDateInput(this.campaignData?.endDate);
  }

  get minEndLabel(): string {
    const value = this.minEndDate;
    const day = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
    if (!day) return 'the current end date';
    return new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }).format(
      new Date(Number(day[1]), Number(day[2]) - 1, Number(day[3]))
    );
  }

  get name() {
    return this.campaignDetailsForm.get('name');
  }
  get description() {
    return this.campaignDetailsForm.get('description');
  }
  get startDate() {
    return this.campaignDetailsForm.get('startDate');
  }
  get endDate() {
    return this.campaignDetailsForm.get('endDate');
  }

  handleSubmit() {
    this.submitted = true;
    if (this.campaignDetailsForm.invalid) return;
    const data = {
      ...this.campaignData,
      name: this.name?.value,
      description: this.description?.value,
      startDate: this.startDate?.value,
      endDate: this.endDate?.value,
      // engagementSchedules: [
      //   {
      //     startDate: this.startDate?.value,
      //     endDate: this.endDate?.value,
      //   },
      // ],
    };
    this.campaignsService
      .editCampaign(this.campaignData.id, data, false)
      .subscribe(() => {
        this.onClose.emit();
      });
  }

  validateEndDate() {
    // this.validateStartDate()
    if (this.endDate?.value) {
      const inputDate = new Date(this.endDate.value);
      const minDate = new Date(this.campaignData.endDate!);
      if (inputDate < minDate) {
        this.endDate?.setErrors({ minDate: true });
      } else {
        this.endDate?.setErrors(null);
      }
    }
  }

  ngOnInit() {
    // Date inputs only show YYYY-MM-DD; a timestamp would leave them blank.
    this.campaignDetailsForm.patchValue({
      name: this.campaignData?.name,
      description: this.campaignData?.description,
      startDate: toDateInput(this.campaignData?.startDate),
      endDate: toDateInput(this.campaignData?.endDate),
    });
  }
}

/** "2026-10-30T00:00:00Z" → "2026-10-30"; other values unchanged. */
function toDateInput(value: string | null | undefined): string {
  if (!value) return '';
  return /^\d{4}-\d{2}-\d{2}T/.test(value) ? value.slice(0, 10) : value;
}
